/**
 * The quote page's words for a refused approval — `docs/visit-page.md` §26.3,
 * Board 17 G. Every string is the board's; the support code arrives from the
 * server (`409 approval_visits_failed {supportCode}`, or
 * `GET /api/v1/quotes/:id/approval-refused` after a reload).
 */
export const APPROVAL_REFUSED = {
  headline: 'Not approved — its visits couldn’t all be made, so nothing changed.',
  /** *… Rowted support can see why (AP-7731).* */
  body: (supportCode: string) =>
    `The quote, the job and the schedule are as they were. Try again; if it happens again, Rowted support can see why (${supportCode}).`,
  retry: 'Try again',
} as const

/**
 * The Proposal tab's approval row — folder 51 Board 10 C's component, which
 * `docs/job-stages.md` §8 A puts on a quote's rail after the office approves:
 * *Approved by Karen Whitmer — by phone* · *recorded by Tom Reyes · Tue Oct
 * 27, 4:10 PM* · what was said, in quotes. Only those three parts (§8 A); the
 * board's change-order figures belong to folder 51.
 *
 * *by phone* is the board's; *in person*, *by text* and *by email* are the
 * same board's sentence (*If Karen says yes in person, on the phone, by text
 * or by email …*). With no *How* recorded the row says who, and stops.
 */
export const APPROVAL_ROW = {
  how: {
    in_person: 'in person',
    phone: 'by phone',
    text: 'by text',
    email: 'by email',
  },
  /** *Approved by Karen Whitmer — by phone*. */
  title: (name: string, how: string | null) => (how ? `Approved by ${name} — ${how}` : `Approved by ${name}`),
  /** *recorded by Tom Reyes · Tue Oct 27, 4:10 PM*. */
  recorded: (user: string, day: string, time: string) => `recorded by ${user} · ${day}, ${time}`,
  /** What the customer said: *“Karen called back — yes to all three, and the lighting too.”* */
  said: (note: string) => `“${note.trim()}”`,
} as const
